/**
 * describes API Id values for mot types coming from efa sta api
 */
export var EFA_STA_MOT_TYPE;
(function (EFA_STA_MOT_TYPE) {
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["ANY"] = 0] = "ANY";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["TRAIN_URBAN"] = 2] = "TRAIN_URBAN";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["BUS"] = 3] = "BUS";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["BUS_CITYBUS"] = 4] = "BUS_CITYBUS";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["TRAIN"] = 6] = "TRAIN";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["CABLE_CAR_1"] = 11] = "CABLE_CAR_1";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["CABLE_CAR_2"] = 12] = "CABLE_CAR_2";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["ON_HOLD_1"] = 97] = "ON_HOLD_1";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["ON_HOLD_2"] = 98] = "ON_HOLD_2";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["FOOTPATH_1"] = 99] = "FOOTPATH_1";
    EFA_STA_MOT_TYPE[EFA_STA_MOT_TYPE["FOOTPATH_2"] = 100] = "FOOTPATH_2";
})(EFA_STA_MOT_TYPE || (EFA_STA_MOT_TYPE = {}));
